export class Haptics {
  private static canVibrate(): boolean {
    return typeof navigator !== 'undefined' && 'vibrate' in navigator;
  }

  /**
   * Rung siêu nhẹ khi bước đi hoặc chạm nút (10ms)
   */
  public static tap(): void {
    if (this.canVibrate()) {
      try {
        navigator.vibrate(10);
      } catch {
        // ignore
      }
    }
  }

  /**
   * Rung giật xích khi chó kéo ghì chân (15ms)
   */
  public static leashTension(): void {
    if (this.canVibrate()) {
      try {
        navigator.vibrate(18);
      } catch {
        // ignore
      }
    }
  }

  /**
   * Chó khựng lại ngồi thụp xả phân (Rung 3 nhịp dồn dập)
   */
  public static dogPoopSquat(): void {
    if (this.canVibrate()) {
      try {
        navigator.vibrate([40, 60, 40, 60, 80]);
      } catch {
        // ignore
      }
    }
  }

  /**
   * Nhịp tim hồi hộp trong 3s đếm ngược Ma trận Quyết định
   */
  public static heartbeatPulse(): void {
    if (this.canVibrate()) {
      try {
        navigator.vibrate([25, 450, 25]);
      } catch {
        // ignore
      }
    }
  }

  /**
   * Cảnh báo cực mạnh khi bị Camera / Quán nước / Bác tổ trưởng tóm sống!
   */
  public static alertCaught(): void {
    if (this.canVibrate()) {
      try {
        navigator.vibrate([200, 100, 250, 100, 300]);
      } catch {
        // ignore
      }
    }
  }

  /**
   * Sút trượt QTE - Giày dính trọn bãi phân
   */
  public static qteFailed(): void {
    if (this.canVibrate()) {
      try {
        navigator.vibrate([150, 80, 150]);
      } catch {
        // ignore
      }
    }
  }

  /**
   * Sút thành công bàn thắng vàng
   */
  public static qteSuccess(): void {
    if (this.canVibrate()) {
      try {
        navigator.vibrate([50, 50, 100]);
      } catch {
        // ignore
      }
    }
  }
}
